import Vue from 'vue'
import notice from './noticeDialog.vue'

let noticeConstructor = Vue.extend(notice)
let theNotice = function (cont, done, cancel) {
  // eslint-disable-next-line new-cap
  let noticeDom = new noticeConstructor({
    el: document.createElement('div')
  })
  noticeDom.cont = cont
  noticeDom.btnOk = function () {
    done()
    noticeDom.isShow = false
  }
  noticeDom.btnCancel = function () {
    cancel()
    noticeDom.isShow = false
  }
  document.body.appendChild(noticeDom.$el)
}
// 全局注册
function registryNotice () {
  Vue.prototype.$myNotice = theNotice
}
export default registryNotice



// WEBPACK FOOTER //
// ./src/components/noticeDialog.js